module.exports = __webpack_public_path__ + "01_long_grey.779ffbb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_long_grey.png
// module id = svk7
// module chunks = 0